import JsonView from 'react18-json-view'
import 'react18-json-view/src/style.css'

interface Props {
  jsonData: object
}
const BaseJsonView = ({ jsonData }: Props) => (
  <JsonView
    src={jsonData}
    displaySize={'expanded'}
    editable={false}
    enableClipboard={false}
    collapsed={15}
    style={{ padding: '1rem', maxHeight: '45rem', overflowY: 'scroll' }}
  />
)

export default BaseJsonView
